import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './StripeIntegration.module.scss';
import Box from '../../common/Box';
import InlineEdit from '../../common/InlineEdit';

function StripeIntegration(props) {
  const [secretKey, setSecretKey] = useState(null);
  const [publishableKey, setPublishableKey] = useState(props.publishable_key);

  const saveSecretKey = (value) => {
    setSecretKey(value);
    props.setIntegration(null, value);
  };

  const savePublishableKey = (value) => {
    setPublishableKey(value);
    props.setIntegration(value);
  };

  return (
    <Box toolbar="Stripe Integration" title="Setup your Stripe keys">
      <div className={styles.body}>
        <dl>
          <dt>Publishable key:</dt>
          <dd>
            <InlineEdit value={publishableKey} onChange={savePublishableKey} emptyValue="Add Key" cancel />
          </dd>

          <dt>Secret key:</dt>
          <dd>
            <InlineEdit
              value={secretKey}
              onChange={saveSecretKey}
              emptyValue="Add Key"
              hidden={props.has_secret_key}
              cancel
            />
          </dd>
        </dl>
      </div>
    </Box>
  );
}

export default StripeIntegration;

StripeIntegration.propTypes = {
  has_secret_key: PropTypes.bool,
  publishable_key: PropTypes.string,
  setIntegration: PropTypes.func.isRequired,
};
